import { refresh } from 'less';

/**
 * 基础路由
 * */
export const RouterMap = [
  {
    path: "*",
    redirect: "/404"
  },
  // 首页
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/Index'),
    meta: { title: '首页', keepAlive: false, refresh: true },
  },
  {
    path: '/',
    redirect: '/index',
    component: () => import('@/views/Layouts'),
    children: [
      // 问卷调查
      {
        path: '/questionnaire-list',
        name: 'questionnaire-list',
        component: () => import('@/views/Questionnaire/list'),
        meta: { title: '调查问卷列表' }
      },
      {
        path: '/questionnaire-detail',
        name: 'questionnaire-detail',
        component: () => import('@/views/Questionnaire/detail'),
        meta: { title: '调查问卷详情' }
      },
      {
        path: '/collect-list',
        name: 'collect-list',
        component: () => import('@/views/Collect/list'),
        meta: { title: '民意调查列表' }
      },
      {
        path: '/collect-detail',
        name: 'collect-detail',
        component: () => import('@/views/Collect/detail'),
        meta: { title: '民意调查详情' }
      },
      {
        path: '/jySpecialSubject-detail',
        name: 'jySpecialSubject-detail',
        component: () => import('@/views/JYSpecialSubject/detail'),
        meta: { title: '专题详情' }
      },
      {
        path: '/hotSpot-list',
        name: 'hotSpot-list',
        component: () => import('@/views/HotSpot/list'),
        meta: { title: '民情热点列表' }
      },
      {
        path: '/hotSpot-detail',
        name: 'hotSpot-detail',
        component: () => import('@/views/HotSpot/detail'),
        meta: { title: '民情热点详情' }
      },
      {
        path: '/microSuggest-list',
        name: 'microSuggest-list',
        component: () => import('@/views/MicroSuggest/list'),
        meta: { title: '微建言列表' }
      },
      {
        path: '/peopleWill-list',
        name: 'peopleWill-list',
        component: () => import('@/views/peopleWill/list'),
        meta: { title: '民意智库' }
      },
      {
        path: '/peopleWindow-list',
        name: 'peopleWindow-list',
        component: () => import('@/views/peopleWill/window'),
        meta: { title: '民声之窗' }
      },
    ]
  },
  {
    path: '/wap',
    component: () => import('@/views/Wap/layout'),
    children: [
      // wap首页
      {
        path: '/wap/index',
        name: 'wapIndex',
        component: () => import('@/views/Wap/index'),
        meta: { title: ' 时刻微民意' },
      },
      {
        path: '/wap/advice-detail',
        name: 'wap-advice-detail',
        component: () => import('@/views/Wap/advice-detail'),
        meta: { title: ' 建言献策' },
      },
      {
        path: '/wap/collect-detail',
        name: 'wap-collect-detail',
        component: () => import('@/views/Wap/collect-detail'),
        meta: { title: ' 民意调查' },
      },
      {
        path: '/wap/question-detail',
        name: 'wap-question-detail',
        component: () => import('@/views/Wap/question-detail'),
        meta: { title: ' 问卷调查' },
      },
      {
        path: '/wap/JYSpecialSubject-detail',
        name: 'wap-JYSpecialSubject-detail',
        component: () => import('@/views/Wap/JYSpecialSubject-detail'),
        meta: { title: ' 问卷调查' },
      },
      {
        path: '/wap/news-detail',
        name: 'wap-news-detail',
        component: () => import('@/views/Wap/news-detail'),
        meta: { title: ' 问卷调查' },
      },
    ]
  }
];
